import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';
import type { UploadedFiles } from '../../../../../types/Shared';
import { CurrencyFormatDisplay } from '../../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

export default function PotentialProject({ potentialProject, files }: { potentialProject: any; files: UploadedFiles[] }) {
  const { id = 0 } = useParams();
  const _queryClient = useQueryClient();

  const _potentialProjectFiles = files?.filter((file) => file.field === 'potentialProject.additionalDocs');
  return (
    <>
      {potentialProject && (
        <section aria-labelledby='applicant-information-title'>
          <div className='bg-white shadow sm:rounded-lg'>
            <div className='py-5'>
              <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
                <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
                  Potential Project
                </h2>
                <p className='mt-1 max-w-2xl text-sm text-gray-500'>Details of an potential project.</p>
              </div>
            </div>
            <div className='border-t border-gray-200 px-4 py-5 sm:px-6 space-y-5'>
              <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Address</dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    {potentialProject.streetAddress}, {potentialProject.city}, {potentialProject.state}, {potentialProject.zipCode}
                  </dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Deal Type</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{potentialProject.dealType}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Proposed Number of Units</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{potentialProject.proposedUnits}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Is Proposed Project "By-Right" ?</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{potentialProject.byRight},</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Construction Type</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{potentialProject.constructionType}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Acquisition Type</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{potentialProject.acquisitionType}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Status of Site Control</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{potentialProject.siteControlStatus}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Estimated Acquisition Cost</dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    <CurrencyFormatDisplay value={potentialProject.acquisitionCost} prefix='$' />
                  </dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Estimated Development Cost</dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    <CurrencyFormatDisplay value={potentialProject.developmentCost} prefix='$' />
                  </dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Estimated Pre-Development Cost</dt>
                  <dd className='mt-1 text-sm text-gray-900'>
                    <CurrencyFormatDisplay value={potentialProject.preDevelopmentCost} prefix='$' />
                  </dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>More Information About Project</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{potentialProject.moreInfo}</dd>
                </div>
                <div className='sm:col-span-1'>
                  <dt className='text-sm font-medium text-gray-500'>Use of Financing</dt>
                  <dd className='mt-1 text-sm text-gray-900'>{potentialProject.financingUse.map((fu: string) => `${fu}, `)}</dd>
                </div>
              </dl>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
